import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';

import SuccessIcon from '../MUI/Icons/SuccessIcon';
import useStyles from './makeStyles';

const ContractDefaultCoveragesDescription = ({ descriptions }) => {
  const classes = useStyles();

  return (
    <>
      {descriptions.map((description) => (
        <Grid className={classes.infoGrid} container direction="row" key={uniqueId()}>
          <Grid item className={classes.icon}>
            <SuccessIcon />
          </Grid>
          <Grid item xs={10}>
            <Typography className={classes.label}>
              {description.label}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

ContractDefaultCoveragesDescription.propTypes = {
  descriptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
  })).isRequired,
};

export default ContractDefaultCoveragesDescription;
